export default "__VITE_ASSET__dc7cb42c__"